// extracted by mini-css-extract-plugin
export default {"login":"style_login__7fOKp","outerBox":"style_outerBox__fVgx2","formdiv":"style_formdiv__DruZB","input":"style_input__E4vTF"};